import { get } from "lodash";
import { z } from "zod";
import { dayjsDate } from "./dayjsDate";
export const boolean = (options)=>{
    return z.boolean({
        message: 'general.validations.invalid'
    }).refine((val)=>{
        if (!options?.required) {
            return true;
        }
        return val;
    }, {
        message: 'general.validations.required'
    });
};
export const date = (options)=>{
    return string().superRefine((dateStr, ctx)=>{
        if (!options?.required && !dateStr) {
            return true;
        }
        if (!dayjsDate(dateStr, 'MM/DD/YYYY', true).isValid()) {
            ctx.addIssue({
                code: z.ZodIssueCode.custom,
                message: 'general.validations.date'
            });
            return false;
        }
        const minDate = typeof options?.min === 'string' ? get(ctx, options.min) : options?.min;
        if (!minDate) {
            return true;
        }
        if (!dayjsDate(dateStr).isSameOrAfter(minDate, 'day')) {
            ctx.addIssue({
                code: z.ZodIssueCode.custom,
                message: 'general.validations.dateMin'
            });
            return false;
        }
        return true;
    });
};
export const email = (options)=>{
    const required = options?.required ?? true;
    return string().refine((value)=>{
        if (!required && !value) {
            return true;
        }
        return z.string().email().safeParse(value).success;
    }, 'general.validations.email');
};
export const phone = (options)=>{
    return string().refine((phone)=>{
        if (!options?.required && phone.replace('+1', '') === '') {
            return true;
        }
        return new RegExp(/^\+1\d{10}$/).test(phone);
    }, 'general.validations.phone');
};
export const ssn = (options)=>{
    return string().refine((ssn)=>{
        if (!options?.required && ssn === '') {
            return true;
        }
        return new RegExp(/^\d{9}$/).test(ssn);
    }, 'general.validations.ssn');
};
const URL_BLOCKED_SCHEMES = new Set([
    'javascript:',
    'data:',
    'vbscript:',
    'file:'
]);
export const url = (options)=>{
    return string().refine((value)=>{
        if (!options?.required && !value) {
            return true;
        }
        if (!value.startsWith('https://')) {
            return false;
        }
        try {
            const parsed = new URL(value);
            if (URL_BLOCKED_SCHEMES.has(parsed.protocol)) {
                return false;
            }
            if (parsed.protocol !== 'https:') {
                return false;
            }
            if (!parsed.hostname || !parsed.hostname.includes('.')) {
                return false;
            }
            return true;
        } catch  {
            return false;
        }
    }, 'general.validations.url');
};
export const zip = (options)=>{
    return string().refine((zip)=>{
        if (!options?.required && zip === '') {
            return true;
        }
        return new RegExp(/^\d{5}(?:\d{4})?$/).test(zip);
    }, 'general.validations.zip');
};
export const string = (options)=>{
    let base = z.string({
        message: 'general.validations.invalid'
    });
    if (options?.required) {
        base = base.min(1, 'general.validations.required');
    }
    if (options?.maxLength) {
        base = base.max(options.maxLength, 'general.validations.tooLong');
    }
    return base;
};
export const number = (options)=>{
    let base = z.number({
        message: 'general.validations.invalid'
    });
    if (options?.min || options?.min === 0) {
        base = base.min(options.min, 'general.validations.min');
    }
    if (options?.max || options?.max === 0) {
        base = base.max(options.max, 'general.validations.max');
    }
    return base;
};

//# sourceMappingURL=validators.js.map